export const adminTabIndex = {
  usersTab: 1,
  rolesTab: 2,
  recurrentEntitiesTab: 3
}
